;(function(){
  // 1) Inject a header into every drill-down panel
  document.querySelectorAll('.ltn__main-menu .menu-panel').forEach(function(panel){
    var h = document.createElement('div');
    h.className = 'menu-panel-header';
    h.textContent = 'Shop Departments';
    panel.insertBefore(h, panel.firstChild);
  });

  // 2) Grab references
  var deptBtn = document.querySelector('.ltn__main-menu > ul > li:first-child');
  var overlay = document.querySelector('.menu-overlay');
  var panels  = document.querySelectorAll('.ltn__main-menu .menu-panel');
  var activePanel = panels[0];

  // helper to show a panel
  function showPanel(next){
    panels.forEach(p => p.classList.remove('active'));
    next.classList.add('active');
    activePanel = next;
  }

  // 3) Open root menu
  deptBtn.addEventListener('click', function(e){
    e.preventDefault();
    panels.forEach(function(p){
      p.querySelector('.menu-panel-header').textContent = 'Shop Departments';
    });
    showPanel(panels[0]);
    document.body.classList.add('menu-open');
  });

  // 4) Clicking on any <a> inside a panel to drill in
  panels.forEach(function(panel){
    panel.querySelectorAll('li > a').forEach(function(link){
      link.addEventListener('click', function(e){
        var targetSelector = this.getAttribute('href');
        var nextPanel = document.querySelector(targetSelector);
        if(nextPanel){
          e.preventDefault();
          var title = this.textContent.trim();
          nextPanel.querySelector('.menu-panel-header').textContent = title;
          showPanel(nextPanel);
        }
      });
    });
  });

  // 5) Back buttons inside panels
  panels.forEach(function(panel){
    panel.querySelectorAll('button').forEach(function(btn){
      btn.addEventListener('click', function(){
        var parentSel = panel.getAttribute('data-parent');
        if(parentSel){
          var parent = document.querySelector(parentSel);
          showPanel(parent);
        } else {
          panel.classList.remove('active');
          document.body.classList.remove('menu-open');
        }
      });
    });
  });

  // 6) Clicking overlay closes everything
  overlay.addEventListener('click', function(){
    activePanel.classList.remove('active');
    document.body.classList.remove('menu-open');
  });

  // Drilldown Sidebar Logic (only on collection pages)
  if (document.body.classList.contains('template-collection')) {
const showMoreBtn      = document.querySelector('.show-more-btn');
const showLessBtn      = document.querySelector('.show-less-btn');   // ✅ NEW
const expandAllBtn     = document.querySelector('.expand-all-btn');
const collapseTopBtn   = document.querySelector('.collapse-top-btn'); // ✅ NEW
const collapseEarlyBtn = document.querySelector('.collapse-early-btn');
    const allItems        = () => Array.from(document.querySelectorAll('.drilldown-item'));
    const hiddenItems     = () => allItems().filter(el => el.classList.contains('hidden-item'));
    let visibleCount = 10;

function updateControls() {
  const isFullyExpanded = hiddenItems().length === 0;
  const hasExpanded = visibleCount > 10;

  // Show More: only if there are hidden items
  showMoreBtn.classList.toggle('hidden', isFullyExpanded === true);

  // Show Less: only if user expanded at least one chunk and list is not full
  showLessBtn.classList.toggle('hidden', !(hasExpanded && !isFullyExpanded));

  // Expand All: only if not fully expanded
  expandAllBtn.classList.toggle('hidden', isFullyExpanded === true);

  // Collapse Top: only when fully expanded
  collapseTopBtn.classList.toggle('hidden', isFullyExpanded === false);

  // Collapse Early: only when partially expanded
  collapseEarlyBtn.classList.toggle('hidden', !(hasExpanded && !isFullyExpanded));
}


if (showMoreBtn) {
  showMoreBtn.addEventListener('click', function () {
    const currentlyHidden = hiddenItems();

    if (currentlyHidden.length > 0) {
      // Show next 10
      const toShow = currentlyHidden.slice(0, 10);
      toShow.forEach(el => el.classList.remove('hidden-item'));
      visibleCount += toShow.length;
    }

    updateControls();
  });
}

// Show Less: undo one "Show More"
if (showLessBtn) {
  showLessBtn.addEventListener('click', function () {
    const all = allItems();
    const toHideStart = Math.max(10, visibleCount - 10); // never hide initial 10
const toHide = all.slice(toHideStart, visibleCount);
    toHide.forEach(el => el.classList.add('hidden-item'));
    visibleCount -= toHide.length;
    updateControls();
  });
}

// Collapse All (top)
if (collapseTopBtn) {
  collapseTopBtn.addEventListener('click', function () {
    allItems().forEach((el, i) => {
      if (i >= 10) el.classList.add('hidden-item');
    });
    visibleCount = 10;
    updateControls();
  });
}


    if (expandAllBtn) {
      expandAllBtn.addEventListener('click', function() {
        if (hiddenItems().length === 0) {
          allItems().forEach((el, i) => {
            if (i >= 10) el.classList.add('hidden-item');
          });
          visibleCount = 10;
        } else {
          hiddenItems().forEach(el => el.classList.remove('hidden-item'));
          visibleCount = allItems().length;
        }
        updateControls();
      });
    }

    if (collapseEarlyBtn) {
      collapseEarlyBtn.addEventListener('click', function () {
        allItems().forEach((el, i) => {
          if (i >= 10) el.classList.add('hidden-item');
        });
        visibleCount = 10;
        updateControls();
      });
    }

    updateControls(); // Initialize state

    // Redirect when checkbox is ticked
    document.querySelectorAll('.sidebar-drilldown input[type="checkbox"]').forEach(cb => {
      cb.addEventListener('change', function () {
        if (cb.checked) {
          const currentParams = window.location.search;
          window.location.href = cb.dataset.href + currentParams;
        }
      });
    });
  }

})();
